import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ErrorHandlingService } from '@core/services/error-handling.service';
import { catchError, throwError } from 'rxjs';
import { SKIP_AUTH_ERROR_HANDLING } from './http-context.tokens';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandlingService = inject(ErrorHandlingService);

  if (req.context.get(SKIP_AUTH_ERROR_HANDLING)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (req.headers.has('NO_ALERT') || error.status === 401) {
        return throwError(() => error);
      }

      errorHandlingService.handleError(error);
      return throwError(() => error);
    }),
  );
};
